module.exports = __webpack_public_path__ + "img/collection_a.acdc2963.png";